module.exports = __webpack_public_path__ + "img/Weapon_26.d0cca31e.png";